import { select, scaleLinear, axisBottom, axisLeft } from 'd3';
import { hexbin } from 'd3-hexbin';
import { ChartCtrParams } from '../types';

export default class HexBin {
  elementId = '';
  el = {};

  constructor(params?: ChartCtrParams) {
    this.elementId = params.elementId;
  }

  loadData(raw: any[], options?: { test: '' }) {
    const margin = { top: 30, right: 30, bottom: 70, left: 60 };
    const width = 460 - margin.left - margin.right;
    const height = 400 - margin.top - margin.bottom;

    const svg = select(this.elementId)
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    const xDomain = [5, 18];
    const xScale = scaleLinear().range([0, width]).domain(xDomain);

    svg
      .append('g')
      .attr('transform', 'translate(0,' + height + ')')
      .call(axisBottom(xScale));

    const yDomain = [5, 20];
    const yRange = [height, 0];
    const yScale = scaleLinear().domain(yDomain).range(yRange);

    svg.append('g').call(axisLeft(yScale));
    const data = raw.map((d) => [xScale(d.x), yScale(d.y)]);

    const color = scaleLinear()
      .domain([0, 600]) // Number of points in the bin?
      // @ts-ignore
      .range(['transparent', 'steelblue']);

    const hex = hexbin()
      .radius(9) // size of the bin in px
      .extent([
        [0, 0],
        [width, height],
      ]);

    svg.append('clipPath').attr('id', 'clip').append('rect').attr('width', width).attr('height', height);

    svg
      .append('g')
      .attr('clip-path', 'url(#clip)')
      .selectAll('path')
      .data(hex(data))
      .enter()
      .append('path')
      .attr('d', hex.hexagon())
      .attr('transform', function (d) {
        // @ts-ignore
        return 'translate(' + d.x + ',' + d.y + ')';
      })
      .attr('fill', function (d) {
        // @ts-ignore
        return color(d.length);
      })
      .attr('stroke', 'black')
      .attr('stroke-width', '0.1');
  }
}
